Vendd.Scripts.load(function () {
    var $wrapper = $(".x-product-list-gtl");

});
